import React from 'react'
import { useNavigate } from 'react-router-dom'

const Topic1 = () => {

  const navigate = useNavigate()

  return (
    <div className="py-5 flex flex-col gap-5">
      <h2 className="text-xl sm:text-2xl xl:text-3xl font-bold">Sporing af en pakke</h2>
      <div className="tekst gap-10 flex flex-col">
        <div className="introduction font-medium">
          <p>Du kan, både som køber og sælger, spore den afsendte pakke.</p>
        </div>
        <div className="content flex flex-col gap-5">
          <div className="intro flex flex-col gap-2">
            <h2 className="font-bold text-lg">Sådan gør du</h2>
            <p>Under <span className="underline text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer" onClick={() => navigate('/dashboard/minebøger')}>Mine bøger</span> skal du vælge "<span className="font-semibold">Se detaljer</span>" ud for den afsendte bog. Her finder du et <span className="font-medium">pakkenummer</span>, der ved et enkelt klik fører dig til forsendelsesfirmaets hjemmeside, hvor pakken kan spores ved indtastning af pakkenummeret.</p>
          </div>
        </div>
        <div className="questions">
          <p>Har du spørgsmål eller brug for yderligere hjælp til at spore din pakke? <span className="text-emerald-600 hover:text-emerald-700 transition-[] cursor-pointer text-nowrap" onClick={() => navigate('/kontakt')}>Kontakt os</span>.</p>
        </div>
      </div>
    </div>
  )
}

export default Topic1